import React from "react";

import { ReactComponent as ContactIcon } from "../../../../assets/images/Help/icon_section_contact.svg";
import common from "../common.module.scss";

const HelpContactSection = () => {
  return (
    <section id="contact" className={common.section}>
      <p className={common.heading}>
        <span className={common.group}>
          <ContactIcon />
          個別のお問い合わせ
        </span>
      </p>
      <p className={common.description}>
        上記をご確認いただいても解決しない場合は、以下のフォームよりお問い合わせください。
        <br />
        資料請求、製品紹介等に関するお問い合わせにつきましては、
        <a
          className={common.link}
          href="https://www.enageed.jp/contact"
          target="_blank"
          rel="noopener noreferrer"
        >
          こちら
        </a>
        をご利用ください。
      </p>
      <div className={common.content}>
        <iframe
          src="https://noteforms.com/forms/nit4op"
          width={"100%"}
          height={"1050"}
          data-service="noteforms"
          loading="lazy"
          title="個別のお問い合わせフォーム"
        />
      </div>
    </section>
  );
};

export default HelpContactSection;
